
import {useCallback, useEffect, useState} from "react";
import React from "react";
import axios from "axios";
import Select from "react-select";
import "./style.css";
import {url} from "./BaseUrl"; // Import your CSS file
const tele = window.Telegram.WebApp;
tele.expand();
function Groups(){
    const [isLoading, setIsLoading] = useState(false); // State for loading indicator

    const [groups, setGroups] = useState([]);
    const user = tele.initDataUnsafe?.user?.username || tele.initDataUnsafe?.user?.first_name + ' ' + tele.initDataUnsafe?.user?.last_name;
    const user_id = tele.initDataUnsafe?.user?.id;
    const [count, setCount] = useState(0);
    const [Id_user, setId_user] = useState(0);
    const maxSelection = 8;

    //console.log(count)
    async function getGroups() {
        setIsLoading(true);
        try {
            await axios.post(url+'/get_groups', {'user_id':user_id},
                {headers: {'Content-Type': 'application/json', 'Accept': 'application/json', 'Access-Control-Allow-Origin': '*'}})
                .then((res) => {
                    setGroups(res.data['data']);
                    setFilteredGroups(res.data['data']);
                    setCount(res.data['user']['count']);
                   setId_user(res.data['user']['id_user']);
                })
        }catch (error) {
            console.log(error);
        }finally {
            setIsLoading(false);
        }

    }useEffect(() => {
        getGroups();
    }, []);

    const [selectedGroup, setSelectedGroups] = useState([]);

    const handleCheckboxChange1 = (event, id) => {
        const updatedSelectedEmployees = [...selectedGroup];
        const isSelected = updatedSelectedEmployees.includes(id);

        if (isSelected) {
            updatedSelectedEmployees.splice(updatedSelectedEmployees.indexOf(id), 1);
        }else {
            if(updatedSelectedEmployees.length >= maxSelection - count){
                alert("لا يمكنك تحديد المجموعات أكثر من 8 مجموعات");
                //setCount( count + updatedSelectedEmployees.length);
                return
            }
            updatedSelectedEmployees.push(id);
        }
        setSelectedGroups(updatedSelectedEmployees);
        if(updatedSelectedEmployees.length === 0){
            tele.MainButton.hide();
        }else{
            tele.MainButton.show();
            tele.MainButton.setParams({
                text: `Selected Groups: ${updatedSelectedEmployees.length}`,});
        }
    };

    const [filteredGroups, setFilteredGroups] = useState([]); // State for filtered data
    const [searchTerm, setSearchTerm] = useState([]); // State for search term
    const [selectedOptions, setSelectedOptions] = useState([]); // State for selected options
    const handleSearch = (selectedOption) => {
        setSearchTerm(selectedOption.map((item) => item.value)); // Extract values from selected options
        const filteredData = groups.filter((group) =>
            selectedOption.some((option) =>
                (group.nameAr && group.nameAr.includes(option.value)) ||
                (group.nameEn && group.nameEn.toLowerCase().includes(option.value.toLowerCase()))
            )
        );
        if (selectedOption.length === 0) {
            setFilteredGroups(groups);
        } else {
            setFilteredGroups(filteredData);
        }
        // Update selected options based on search results (optional)
        const newSelectedOptions = selectedOption.filter((option) => groups.some((group) => group.nameAr === option.value || group.nameEn === option.value));
        setSelectedOptions(newSelectedOptions);
    };
    // Options for the select component (replace with actual data if needed)
    const options = groups.map((group) => ({
        value:  group.nameEn, // Use nameAr or nameEn based on availability
        label: group.nameAr , // Use nameAr or nameEn based on availability
    }));



    const onSendData = useCallback(() => {
        tele.MainButton.hide();
        alert('رجاء إنتظر أن يتم ارسال القروبات إليك:');
        const data = {
            groups: selectedGroup,
            user: user,
            id:user_id,
        }
        const response = fetch(url+'/send', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(data)
        }).then(response => response.json()).then(
            data => {
                // Handle successful response data here (e.g., display success message)
                alert('تم الارسال بنجاح:');
                tele.close();
            }
        )

    }, [selectedGroup])
    useEffect(() => {
        tele.onEvent('mainButtonClicked', onSendData)
        return () => {
            tele.offEvent('mainButtonClicked', onSendData)
        }
    }, [onSendData])
    return(
        <>
            {
                Id_user === 0 || Id_user === null || Id_user === undefined?
                <div className="content-center flex flex-row justify-between w-auto h-auto">
                    <div className="bg-white rounded-b mx-auto w-full">
                        <div className="p-2 md:px-10 flex content-center justify-between  m-4" dir="rtl">
                            <h1 className="text-lg font-bold text-[#303BFF] text-right">
                                مرحباَ بك يا <span className="text-lg font-bold text-gray-900 text-right mr-2">{user}</span>
                            </h1>
                        </div>
                        {isLoading ? (
                                <div className="flex content-center items-center justify-center mt-20" dir="rtl"> {/* Center the content horizontally */}
                                    <img className="w-12 h-12 animate-spin mr-4"
                                         src="https://www.svgrepo.com/show/199956/loading-loader.svg"
                                         alt="Loading icon"/> {/* Add margin for spacing */}
                                    <span className="text-xl font-bold">جاري التحميل...</span>
                                </div>
                            ) :
                            (
                                <div className="p-2 pr-4 md:px-8  mt-20 w-full" dir={'rtl'}>
                                    <h1 className="text-3xl font-bold text-red-900 text-center">يجب عليك إدخال رقم القيدك</h1>
                                    <p className={"text-xl font-bold mt-5 text-center"}>طريقة: إرجع إلي البوت و اكتب
                                        "قروبات" و إنتظر رسالة من البوت يقولك فيها دخل رقم القيدك وبعد ما دخله
                                        بنجاح عاود افتحها صفحة هادي. وشكرا</p>
                                </div>
                            )}
                    </div>
                </div>
                :
                <div className="content-center flex flex-row justify-between w-auto h-auto">
                    <div className="bg-white rounded-b mx-auto w-full">
                        <div className="p-2 md:px-10 flex content-center justify-between  m-4" dir="rtl">
                            <h1 className="text-lg font-bold text-[#303BFF] text-right">
                                مرحباَ بك يا <span className="text-lg font-bold text-[#303BFF] text-right mr-2">{user}</span>
                            </h1>
                            {/*<h3 className="text-2xl font-bold text-gray-900 text-right">{Id_user}</h3>*/}
                        </div>
                        {count <8?
                            <div className="p-2 mr-4 md:px-8 flex justify-start mt-2" dir={'rtl'}>
                                <span className="text-sm text-[#303BFF] text-opacity-70 ml-2">عدد المجموعات: {count} </span>
                                <span className="text-sm text-[#303BFF] text-opacity-70">المجموعات المختارة: {selectedGroup.length}</span>
                            </div>
                            :
                            <div className="p-2 pr-4 md:px-8 flex justify-start mt-2" dir={'rtl'}>
                                <span className="text-sm  text-red-700">لقد وصلة لحد أقصى من عدد المجموعات مستهدفة في هذا سيمستر: {count} </span>
                            </div>
                        }
                        <div className="p-2 pr-4 md:px-8 flex justify-start mt-2" dir={'rtl'}>
                            <span className="text-sm  text-red-700">الحد الأقصى لعدد المجموعات الدراسية في هذا الفصل هو 8 مجموعات.</span>
                        </div>
                        <div className="p-2 md:px-8 flex justify-start  m-4" dir={"rtl"}>
                            <Select
                              isMulti
                              value={selectedOptions}
                              onChange={handleSearch}
                              options={options}
                              className="rounded-full w-1/3 max-sm:w-2/3 bg-[#303BFF] bg-opacity-25 text-[#303BFF]"
                              placeholder="بحث"
                            />
                        </div>
                        <div className="p-2 md:px-8 justify-center m-4 mb-6 bg-white rounded-xl">
                            {isLoading ? (
                                <div className="flex items-center justify-center"> {/* Center the content horizontally */}
                                  <img className="w-12 h-12 animate-spin mr-4" src="https://www.svgrepo.com/show/199956/loading-loader.svg" alt="Loading icon" /> {/* Add margin for spacing */}
                                  <span className="text-xl font-bold">جاري التحميل...</span>
                              </div>
                            ):(
                                <table className="w-full text-md bg-white shadow-md rounded mb-4 table-fixed " dir="rtl">
                                    <thead className="flex flex-col items-center   w-full pl-4">
                                        <tr className="border-b text-center justify-between flex w-full  mb-4">
                                            <th className="p-3 px-4 w-1/8">-</th>
                                            <th className="p-3 w-1/8">#</th>
                                            <th className="p-3 w-1/2">اسم المادة</th>
                                            <th className="p-3 w-1/4">رمز المادة</th>
                                            {/*<th className="p-3 w-1/5">الإنضمام</th>*/}
                                        </tr>
                                    </thead>
                                    <tbody className="flex flex-col items-center  overflow-y-scroll h-72 max-h-96 w-full pl-3">
                                        {Array.isArray(filteredGroups)&&(filteredGroups.map((group,index)=>(
                                            <tr className="text-center hover:bg-orange-100 flex w-full  justify-between mb-4">
                                                <td className="p-3 w-1/8 flex items-center justify-center">
                                                    <input type="checkbox" checked={selectedGroup.includes(group.nameEn)}
                                                        onChange={(event) =>
                                                        handleCheckboxChange1(event,group.nameEn)
                                                        }/>
                                                </td>
                                                <td className="p-3 w-1/8 flex items-center justify-center">{index+1}</td>
                                                <td className="p-3 w-1/2 flex items-center justify-center">{group.nameAr}</td>
                                                <td className="p-3 w-1/4 flex items-center justify-center">{group.nameEn}</td>
                                                {/*<td className="p-3 w-1/5 flex items-center justify-center"><a href={group.url}>عرض</a></td>*/}
                                            </tr>
                                        )))}
                                    </tbody>
                                </table>
                            )}
                        </div>
                    </div>
                </div>
            }
        </>
    );

}

export default Groups